import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getInvitationsQueryKey } from "../lib/invitationsQuery"

export function useCancelInvitationMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id }: { id: string }) => {
      const { data } = await axios.delete(`/employees/invitations/${id}`)
      return data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getInvitationsQueryKey() })
    },
  })
}
